import { openDB } from 'idb';
import { FixedDeposit } from '../models/fixed-deposit';

const dbPromise = openDB('fd-db', 1, {
  upgrade(db) {
    db.createObjectStore('fixedDeposit', { keyPath: 'id', autoIncrement: true });
  },
});


export const saveFD = async (fixedDeposit: FixedDeposit): Promise<void> => {
  const db = await dbPromise;
  try {
    await db.add('fixedDeposit', fixedDeposit);
  } catch (error) {
    console.error('Error saving fixedDeposit:', error);
    throw new Error('Could not save fixedDeposit.');
  }
};

export const fetchFDs = async (): Promise<FixedDeposit[]> => {
  const db = await dbPromise;
  try {
    return await db.getAll('fixedDeposit');
  } catch (error) {
    console.error('Error fetching fixedDeposit:', error);
    throw new Error('Could not fetch fixedDeposit.');
  }
};

export const updateFD = async (id: number, updatedData: Omit<FixedDeposit, 'id'>): Promise<void> => {
  const db = await dbPromise;
  await db.put('fixedDeposit', { id, ...updatedData });
};


export const deleteFD = async (id: number): Promise<void> => {
  const db = await dbPromise;
  await db.delete('fixedDeposit', id);
};
